// import ResizableBox from "../ResizableBox";
import React, { useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./DescriptionLinesStyles.js"
import "animate.css/animate.css";

function DescriptionLines(props) {
  const { step, nextStep, 
    buyerTax,
    setBuyerTax,
    sellerTax,
    setSellerTax,
    isYes,
    setIsYes,
    isNo,
    setIsNo,
    submitted,
    questionAnswer,
    governmentRevenue,
    questionNumber,
    setGovernmentRevenue,
    descriptionText,
    answers,
    setAnswers,
    classes
    } = props;

    useEffect(() => {
      let tempAnswer = answers;
      if (submitted && step === 6) {
        console.log("tempAnswer", submitted, tempAnswer);
        tempAnswer.push(buyerTax === descriptionText.buyerTax && sellerTax === descriptionText.sellerTax && isYes === descriptionText.isYes);
        setAnswers(tempAnswer);
      }
    }, [submitted])

  const toggleButton = (yes, no) => {
    if(yes){
      setIsNo(false)
      setIsYes(true)
    }else if(no){
      setIsYes(false)
      setIsNo(true)
    }
  }

  return (
    <>
      { step >= 3 && step < 6 &&
        <div className={`animate__animated animate__bounceIn ${classes.optionContainer}`}>
          <div className={classes.BulletContainer}>
            <p className={classes.bulletText}>1</p>
          </div>
          <p className={classes.subTitleText}>
            {descriptionText.subtitle}
          {/* { questionNumber === 0 ? "Initially the equilibrium price is $10 and equilibrium quantity is 10." : "Initially the equilibrium price is $5 and equilibrium quantity is 5" } */}
          </p>
        </div>
      }
      { step >= 4 && step < 6 &&
        <div className={`animate__animated animate__bounceIn ${classes.optionContainer}`}>
          <div className={classes.BulletContainer}>
            <p className={classes.bulletText}>2</p>
          </div>
          <p className={classes.subTitleText}>
          {descriptionText.subtitle2}
          {/* { questionNumber === 0 ? "The $10 tax drives a wedge between buyers and sellers, the buyers now pay $15 and the sellers get only $5 after giving $10 to the government." : "The $9 tax drives a wedge between buyers and sellers, the buyers now pay $11 and the sellers get only $2 after giving $9 to the government" } */}
            </p>
        </div>
      }

      { step >= 5 && step < 6 &&
        <div className={`animate__animated animate__bounceIn ${classes.optionContainer}`}>
          <div className={classes.BulletContainer}>
            <p className={classes.bulletText}>3</p>
          </div>
          <p className={classes.subTitleText}>
          {descriptionText.subtitle3}
          {/* { questionNumber === 0 ? "Only 5 units are sold as that is all buyers will demand at a price of $15 and that’s the amount sellers will be willing to supply at a price of $5." : "Only 2 units are supplied as that is all buyers will demand at a price of $11 and that’s the amount sellers will be willing to supply at a price of $2" } */}
            
          </p>
        </div>
      }

      { step >= 3 && step < 6 &&
        <button className={`Gotit ${classes.button}`} onClick={() => nextStep()}>{step === 5 ? "NEXT" : "GOT IT"}</button>
      }

      {step === 6 &&
        <div className={`animate__animated animate__bounceIn ${classes.step6Container}`}>
          <p className={classes.step6Options}>What is the <b>buyer's</b> incidence of the tax?</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={classes.increamentButton} disabled={buyerTax === 0 || submitted} onClick={() => setBuyerTax(buyerTax-1)}><b>-</b></button>
            <p className={classes.increamentText} style={{ color: submitted ? buyerTax === descriptionText.buyerTax ? "green" : "red" : "#043e4b" }}>${buyerTax}</p>
            <button className={classes.increamentButton} disabled={submitted} onClick={() => setBuyerTax(buyerTax+1)}><b>+</b></button>
          </div>

          <p className={classes.step6Options}>What is the <b>seller's</b> incidence of the tax?</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={classes.increamentButton} disabled={sellerTax === 0 || submitted} onClick={() => setSellerTax(sellerTax-1)}><b>-</b></button>
            <p className={classes.increamentText} style={{ color: submitted ? sellerTax === descriptionText.sellerTax ? "green" : "red" : "#043e4b" }}>${sellerTax}</p>
            <button className={classes.increamentButton} disabled={submitted} onClick={() => setSellerTax(sellerTax+1)}><b>+</b></button>
          </div>

          {
            questionNumber === 2
            ? <p className={classes.step6Options}>Would your answer change if the tax was put on the sellers?</p>
            : <p className={classes.step6Options}>Would your answer change if the tax was put on the buyers?</p>
          }

          <div style={{ display: "flex", alignItems: "center", width: "80%", justifyContent: "space-evenly" }}>
            <button className={classes.yesNoButtons} style={{ backgroundColor: submitted ? isYes === true ? "red" : "#043e4b" : isYes === true ? "#00b1d9" : "#043e4b",  cursor: "pointer" }} disabled={submitted} onClick={() => setIsYes(true)}><b>Yes</b></button>
            <button className={classes.yesNoButtons} style={{ backgroundColor: submitted ? isYes === false ? "green" : "#043e4b" : isYes === false ? "#00b1d9" : "#043e4b", cursor: "pointer" }} disabled={submitted} onClick={() => setIsYes(false)}><b>No</b></button>
          </div>
        </div>}
        {submitted && step === 6 &&
          <p className={classes.amswerDescription6}>
            {descriptionText.answerDescription}
          </p>
        }


      {(step === 7 || step === 1) &&
        <div className={`${classes.questionContainer} animate__animated animate__bounceIn`}>
          <p className={classes.questionText} dangerouslySetInnerHTML={{ __html: questionAnswer.question}} />
          { questionAnswer.index === 2 &&
          <>
          <p className={classes.subTilte7}>Calculate the government revenue.</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={classes.increamentButton} disabled={governmentRevenue === 0 || submitted} onClick={() => setGovernmentRevenue(governmentRevenue-descriptionText.step)}><b>-</b></button>
            <p className={classes.increamentText} style={{ color: submitted ? governmentRevenue === questionAnswer.numberAnswer ? "green" : "red" : "#043e4b" }}>${governmentRevenue}</p>
            <button className={classes.increamentButton} disabled={submitted}  onClick={() => setGovernmentRevenue(governmentRevenue+descriptionText.step)}><b>+</b></button>
          </div>
          </>
          }


          {submitted &&
          <div style={{ display: "flex", flexDirection: "column"}}>
            <p className={classes.answerDescription} dangerouslySetInnerHTML={{ __html: questionAnswer.answerDescription}}></p>
            {/* {questionAnswer.numberAnswer > 0 && <p style={{ padding: "10px 0px", fontSize: 20, color: "#043e4b", margin: 0, textAlign: "start" }}>Answer: 50</p>} */}
          </div>
          }
        </div>
      }
    </>
  )
}

export default withStyles(styles)(DescriptionLines);